import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fc5b713"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = ["src"]

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { getWarningById, getRecordDetail } from '@/api/shop'
import { IRetrospect } from '@/utils/interface'
import ComHeader from '@/components/ComHeader/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const src = ref('')
const init = async () => {
  let res: any = {}
  if (route.query.type === 'task') {
    res = await getRecordDetail(route.params.id as string)
  } else {
    res = await getWarningById({ id: route.params.id })
  }
  if (res.videoUrl) {
    const val = res.videoUrl.substr(-14)
    const year = val.substring(0, 8)
    const begin = year + '000000'
    const end = year + '235959'
    const base = res.videoUrl.substr(0, res.videoUrl.length - 39)
    src.value = `${base}begin=${begin}&end=${end}`
    console.log(src.value)
  }
}

init()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ComHeader, {
      height: 16,
      title: "视频播放"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("iframe", { src: src.value }, null, 8, _hoisted_2)
    ])
  ], 64))
}
}

})